module.exports = __webpack_public_path__ + "static/media/pinterest.f6150e58.png";